import { useSyncExternalStore } from "react";

import { isApplePlatform } from "@/lib/keyboard";

const noSubscription = () => () => {};

/**
 * Whether to print ⌘/⌥ or Ctrl/Alt. The server cannot know, so it renders the
 * Mac spelling and the browser corrects it after hydration.
 */
export function useApplePlatform() {
  return useSyncExternalStore(noSubscription, isApplePlatform, () => true);
}
